export default "__VITE_ASSET__BOUacz0C__"